import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M22.54 22.532a1.57 1.57 0 0 0 0-2.22l-4.193-4.193a.394.394 0 0 1-.056-.494 9.427 9.427 0 1 0-2.67 2.669.394.394 0 0 1 .495.05l4.194 4.193a1.57 1.57 0 0 0 2.23-.005ZM4.162 10.433a6.28 6.28 0 1 1 12.56 0 6.28 6.28 0 0 1-12.56 0Z",
  fill: "#1F1F1F"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }